module.exports = __webpack_public_path__ + "img/nosort.738e5c49.png";